module.exports = __webpack_public_path__ + "img/dz.04222eb4.png";